import { createApp } from 'vue';
import LoginPage from '@app/pages/auth/login.vue';
import useI18n from '@utils/I18n';
import Notifications from '@kyvg/vue3-notification';
import { usePinia } from '@utils/Pinia';

const startLoginPage = async () => {
    const elements = document.querySelectorAll<HTMLElement>('[data-auth-login-page]');
    for (const el of Array.from(elements)) {
        const props = JSON.parse(el.dataset.props);
        const app = createApp(LoginPage, { ...props });
        app.use(await useI18n());
        app.use(Notifications);
        app.use(usePinia());
        app.mount(el);
    }
};

export const init = () => {
    startLoginPage();
};
